import React from 'react'
import language from 'utils/vast-languagepack'
import { Ghost } from 'mdi-material-ui'
import {Paper} from '@material-ui/core'
export default () => (
    <Paper style={{ padding: 30, height:'100%', maxWidth: '100%', border:'solid 1px #AAAAAA', textAlign:'center' }}>
        <h1>{language.general.errors.Four04}</h1>
        <Ghost style={{fontSize: '20rem'}}/>
    </Paper>
);